module.exports = __webpack_public_path__ + "media/images/modal_not_benefit_discount-eb8300508841db1ff599c6dd1e9828ae.png";